const NS = 'RuralPopup';
const CLS = 'ruralPopup';
export const EVT_SET_RURAL = `${CLS}.setPostcode`;

import {CdcService} from '../../../../global/js/cdc';
import {LOCAL_STORE_POSTCODE} from '../../../../global/js/constants';
import {dispatchEvent} from '../../../../global/js/utils';
export class RuralPopup {
	constructor(el) {
		this.el = el;
		this.$el = $(el);
		this.modal = $(`.${CLS}-modal`);
		this.setBtn = this.modal.find('.btn-set');
		this.modalDetail = $('.siteHeader-postcode');
		this.ruralSelected = $('.siteHeader-modalDetail .selected-postcode');
		this.postcode = '';
		this.errorMsg = this.modal.find('.error-msg');
		this.inputPostcode = this.modal.find('input');
		this.cdcService = new CdcService();
	}

	init() {
		if (!this.errorMsg.hasClass('d-none')) {
			this.errorMsg.addClass('d-none');
		}
		this.postcode = window.localStorage.getItem(LOCAL_STORE_POSTCODE);
		if (this.postcode !== '' && this.postcode !== null) {
			this.inputPostcode.val(this.postcode);
			this.setPostcode();
		} else {
			this.cdcService.getDeliveryPostcode().then(({postCode}) => {
				window.localStorage.setItem(LOCAL_STORE_POSTCODE, postCode);
				this.inputPostcode.val(postCode);
				this.setPostcode();
			});
		}
		this.handleSetBtn();
	}

	handleSetBtn() {
		this.setBtn.on('click', () => {
			this.setPostcode();
		});
	}

	setPostcode() {
		const resetRural = () => {
			this.postcode = '';
			this.modalDetail.removeClass('selected');
			this.errorMsg.removeClass('d-none');
			window.localStorage.removeItem('postcode');
			if (window.innerWidth >= 768) {
				this.ruralSelected.html('Set your postcode');
			} else {
				this.ruralSelected.html('');
			}
		};
		const ruralList = window.RURAL_POSTCODES || [];
		let inputVal = $(this.inputPostcode).val();
		let regex = /^\d{4}$/;
		let standardPostcode = '';
		if (inputVal && regex.test(inputVal) && inputVal !== '0000') {
			if (ruralList.includes(inputVal)) {
				window.localStorage.setItem('postcodeType', 'rural');
			} else {
				standardPostcode = inputVal;
				window.localStorage.setItem('postcodeType', 'normal');
			}
			this.postcode = inputVal;
			this.ruralSelected.html(this.postcode);
			this.errorMsg.addClass('d-none');
			this.modalDetail.addClass('selected');
			window.localStorage.setItem('postcode', this.postcode);
			this.modal.modal('hide');
		} else {
			resetRural();
		}
		dispatchEvent('[data-pg="ProductDetailsUpdate"]', 'pdp.setRuralPostcode');
		dispatchEvent('.guaranteed-nextday-delivery', 'checkStoreVariantDetail');
		dispatchEvent('#mainContent', 'checkStoreVariantDetail');
	}
}



// WEBPACK FOOTER //
// D:/AzureDevops/vsts-agent-win-x64-2.202.1_05/_work/394/s/FrontEnd/src/views/widgets/ruralPopup/js/ruralPopup.js